import styled from "styled-components";

export const Container = styled.button`
    width: auto;
    padding: 0 15px;
    height: 50px;
    border-radius: 25px;
    border: none;
    background-color: ${props => props.theme.colors.primary};
    color: #fff;
    font-size: 18px;
    min-width: 150px;
`;